import { ConversationDataDto, MessageDto } from './conversation.dto';
import { ConversationEntity, ConversationMessage } from './conversation.entity';

export const mapMessageDtoToEntity = (
  dto: MessageDto,
  childId: string | number,
): ConversationMessage => ({
  senderId: dto.senderId,
  senderType: dto.senderType,
  message: dto.message,
  attachment: dto.attachment,
  sentDate: dto.sentDate,
  sentTime: dto.sentTime,
  seenAt: dto.seenAt,
  isMe: String(dto.senderId) === String(childId),
});

export const mapConversationDataDtoToEntity = (
  dto: ConversationDataDto,
  childId: string | number,
): ConversationEntity => ({
  id: dto.id,
  supportId: dto.supportId,
  unSeenMessagesCount: dto.unSeenMessagesCount,
  messages: (dto.messages ?? []).map((m) => mapMessageDtoToEntity(m, childId)),
  pagination: {
    currentPage: dto.pagination.currentPage,
    lastPage: dto.pagination.lastPage,
    total: dto.pagination.total,
  },
});
